/* ButtonGroup is an aesthetically pleasing group of buttons.
 *
 * The class requires these properties:
 *   buttons - an array of objects with keys:
 *     "value": this is the value returned when the button is selected
 *     "content": this is the JSX shown within the button, typically a string
 *         that gets rendered as the button's display text
 *     "title": this is the title-text shown on hover
 *   onChange - a function that is provided with the updated value
 *     (which it then is responsible for updating)
 *
 * The class has these optional properties:
 *   value - the initial value of the button selected, defaults to null.
 *   allowEmpty - if false, exactly one button _must_ be selected; otherwise
 *     it defaults to true and _at most_ one button (0 or 1) may be selected.
 *
 * Requires stylesheets/perseus-admin-package/editor.less to look nice.
 */

var React = require('react');
var ReactDOM = require("react-dom");
var styles = require('./styles.js');
var css = require("aphrodite").css;

var ButtonGroup = React.createClass({
    displayName: 'ButtonGroup',

    propTypes: {
        value: React.PropTypes.any,
        buttons: React.PropTypes.arrayOf(React.PropTypes.shape({
            value: React.PropTypes.any.isRequired,
            content: React.PropTypes.node,
            title: React.PropTypes.string
        })).isRequired,
        onChange: React.PropTypes.func.isRequired,
        allowEmpty: React.PropTypes.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            value: null,
            allowEmpty: true
        };
    },

    focus: function focus() {
        ReactDOM.findDOMNode(this).focus();
        return true;
    },

    toggleSelect: function toggleSelect(newValue) {
        var value = this.props.value;

        if (this.props.allowEmpty) {
            // Select the new button or unselect if it's already selected
            this.props.onChange(value !== newValue ? newValue : null);
        } else {
            this.props.onChange(newValue);
        }
    },

    render: function render() {
        var _this = this;

        var value = this.props.value;
        var buttons = this.props.buttons.map(function (button, i) {
            return React.createElement(
                'button',
                { title: button.title,
                    type: 'button',
                    id: "" + i,
                    ref: "button" + i,
                    key: "" + i,
                    className: css(styles.button.buttonStyle, button.value === value && styles.button.selectedStyle),
                    onClick: _this.toggleSelect.bind(_this, button.value)
                },
                button.content || "" + button.value
            );
        });

        var outerStyle = {
            display: 'inline-block'
        };
        return React.createElement(
            'div',
            { style: outerStyle },
            buttons
        );
    }
});

module.exports = ButtonGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-components/button-group.jsx
 ** module id = 83
 ** module chunks = 0 2
 **/